import { Box, Text } from 'grommet';

const ZoningSection = ({ reportData, colorMap }) => {
  return (
    <Box direction="row" wrap gap="xsmall" style={{ zIndex: 10, marginTop: '0.5rem', boxShadow: "none" }}>
      {reportData?.zonings?.map(([label, code], index) => (
        <Box
          key={index}
          background={colorMap[code] || '#cccccc'}
          pad={{ horizontal: 'medium', vertical: 'xsmall' }}
          round="medium"
          elevation="small"
          style={{ boxShadow: "none", marginBottom: '0.5rem' }}
        >
          <Text
            color={code === 'Y' ? 'black' : 'white'}
            size="medium"
          >
            {label}
          </Text>
        </Box>
      ))}
    </Box>
  );
};

export { ZoningSection }